'use strict';
import angular from 'angular';

angular.module('inOutStatus.services', [])

    .factory('InOutStatusService', ['IORestangular', '$q', function (IORestangular, $q) {
        var workflowStatusEnable = IORestangular.all('workflowUsers/enabled');
        var loggedInUserStatus = IORestangular.all('workflowUsers/loggedInUserStatus');
        var usersStatus = IORestangular.all('workflowUsers/usersStatus');
        var userStatus = IORestangular.all('workflowUsers/userStatus');
        var usersStatusActivity = IORestangular.all('workflowUsers/addActivity');
        var availableUsers = IORestangular.all('workflowUsers/availableUsers');
        var unavailableUsers = IORestangular.all('workflowUsers/unavailableUsers');
        var taskAssignments = IORestangular.all('tasks/openTaskAssignmentsForUser');

        var getWorkflowEnableStatus = function () {
            return workflowStatusEnable.customGET(undefined, undefined, undefined, undefined);
        };

        var getCurrentUserStatus = function () {
            return loggedInUserStatus.customGET(undefined, undefined, undefined, undefined);
        };

        var getUsersStatus = function () {
            return usersStatus.customGET(undefined, undefined, undefined, undefined);
        };

        var addCurrentUserActivity = function (paramObj) {
            return usersStatusActivity.customPOST(paramObj, undefined, undefined, undefined);
        };

        var getAvailableUsers = function (paramObj) {
            return availableUsers.customGET(undefined, paramObj, undefined, undefined);
        };

        var getUnavailableUsers = function (paramObj) {
            return unavailableUsers.customGET(undefined, paramObj, undefined, undefined);
        };

        var getOpenTaskAssignmentsForUser = function(paramObj) {
            return taskAssignments.customPOST(paramObj, undefined, undefined, undefined)
        };

        return {
            getCurrentUserStatus: getCurrentUserStatus,
            getUsersStatus: getUsersStatus,
            addCurrentUserActivity: addCurrentUserActivity,
            getAvailableUsers: getAvailableUsers,
            getUnavailableUsers: getUnavailableUsers,
            getOpenTaskAssignmentsForUser: getOpenTaskAssignmentsForUser,
            getWorkflowEnableStatus: getWorkflowEnableStatus
        };
    }]);